import axios from "axios";

// const
const REDIRECT_TO_ALGORITHM_MANAGEMENT = "algorithmManagement/REDIRECT_TO_ALGORITHM_MANAGEMENT";
const ALGORITHM_MANAGEMENT_UPDATE_DATA = "algorithmManagement/ALGORITHM_MANAGEMENT_UPDATE_DATA";
const ALGORITHM_MANAGEMENT_STORE_ALGORITHM_TREE = "algorithmManagement/ALGORITHM_MANAGEMENT_STORE_ALGORITHM_TREE";
const ALGORITHM_MANAGEMENT_STORE_ALGORITHM_CATEGORIES = "algorithmManagement/ALGORITHM_MANAGEMENT_STORE_ALGORITHM_CATEGORIES";
const ALGORITHM_MANAGEMENT_STORE_SHOW_ALGORITHMS = "algorithmManagement/ALGORITHM_MANAGEMENT_STORE_SHOW_ALGORITHMS";
const ALGORITHM_MANAGEMENT_TOGGLE_MODAL = "algorithmManagement/ALGORITHM_MANAGEMENT_TOGGLE_MODAL";
const ALGORITHM_MANAGEMENT_TOGGLE_LOADING = "algorithmManagement/ALGORITHM_MANAGEMENT_TOGGLE_LOADING";

const ALGORITHM_MANAGEMENT_MODAL_SUCCESS_TITLE = "scenes_Algorithm_AlgorithmManagement_modal_success_title";
const ALGORITHM_MANAGEMENT_MODAL_FAIL_TITLE = "scenes_Algorithm_AlgorithmManagement_modal_fail_title";
const ALGORITHM_MANAGEMENT_MODAL_UPDATE_SUCCESS_CONTENT = "scenes_Algorithm_AlgorithmManagement_modal_updateSuccess_content";
const ALGORITHM_MANAGEMENT_MODAL_UPDATE_FAIL_CONTENT = "scenes_Algorithm_AlgorithmManagement_modal_updateFail_content";
const ALGORITHM_MANAGEMENT_MODAL_OFFLINE_SUCCESS_CONTENT = "scenes_Algorithm_AlgorithmManagement_modal_offlineSuccess_content";
const ALGORITHM_MANAGEMENT_MODAL_OFFLINE_FAIL_CONTENT = "scenes_Algorithm_AlgorithmManagement_modal_offlineFail_content";
const ALGORITHM_MANAGEMENT_MODAL_OK_LABEL = "scenes_Algorithm_AlgorithmManagement_modal_OK_label";
const ALGORITHM_MANAGEMENT_MODAL_RETURN_LABEL = "scenes_Algorithm_AlgorithmManagement_modal_return_label";

// reducer
export const algorithmManagement = (state = {
  loading: false,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  categoryVisible: false,
  selectedRowKeys: [],
  showAlgorithms: [],

  algorithmId: "",
  parentName: "",
  category: "",
  algorithmTree: [],
  algorithmCategories: [],
  algorithmCategory: "",
  algorithms: [],
}, action) => {
  switch (action.type) {
    case REDIRECT_TO_ALGORITHM_MANAGEMENT:
      return {
        ...state,
        algorithmId: action.data
      };
    case ALGORITHM_MANAGEMENT_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case ALGORITHM_MANAGEMENT_STORE_ALGORITHM_TREE:
      return {
        ...state,
        algorithmTree: action.data
      };
    case ALGORITHM_MANAGEMENT_STORE_ALGORITHM_CATEGORIES:
      return {
        ...state,
        algorithmCategories: action.data
      };
    case ALGORITHM_MANAGEMENT_STORE_SHOW_ALGORITHMS: {
      let algorithms = state.algorithms.filter(algorithm => {
        return action.data.indexOf(algorithm.id) < 0
      });
      let showAlgorithms = state.showAlgorithms.filter(algorithm => {
        return action.data.indexOf(algorithm.id) < 0
      });
      return {
        ...state,
        modalVisible: false,
        selectedRowKeys: [],
        algorithms: algorithms,
        showAlgorithms: showAlgorithms
      }
    }
    case ALGORITHM_MANAGEMENT_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case ALGORITHM_MANAGEMENT_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * 前页跳转此页，传递参数：algorithm.id
 */
export function redirectToAlgorithmManagementPage(algorithmId) {
  return {
    type: REDIRECT_TO_ALGORITHM_MANAGEMENT,
    data: algorithmId
  };
}

/**
 * update data based
 */
export const updateAlgorithmManagementData = (data) => {
  return {
    type: ALGORITHM_MANAGEMENT_UPDATE_DATA,
    data: data
  }
};

/**
 * get all algorithms & categories
 */
export const getAlgorithmTree = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-algorithm/getAllAlgorithmTree", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeAlgorithmTree(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all algorithms & categories
 */
export const storeAlgorithmTree = (algorithmTree) => {
  return {
    type: ALGORITHM_MANAGEMENT_STORE_ALGORITHM_TREE,
    data: algorithmTree
  }
};

/**
 * get all algorithmCategories
 */
export const getAlgorithmCategories = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-algorithm/getAlgorithmCategoryTree", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeAlgorithmCategories(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all algorithmCategories
 */
export const storeAlgorithmCategories = (algorithmCategories) => {
  return {
    type: ALGORITHM_MANAGEMENT_STORE_ALGORITHM_CATEGORIES,
    data: algorithmCategories
  }
};

/**
 * update algorithms category
 */
export const updateAlgorithmsCategory = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: "/api-algorithm/updateAlgorithmsCategory",
    contentType: "application/json",
    withCredentials: true,
    data: {
      ids: data.algorithmIds,
      category: data.category
    }
  }).then(
    response => {
      if (response.status === 200) {
        console.info("success update algorithms category");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_MANAGEMENT_MODAL_SUCCESS_TITLE,
          modalContent: ALGORITHM_MANAGEMENT_MODAL_UPDATE_SUCCESS_CONTENT,
          modalOk: ALGORITHM_MANAGEMENT_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_MANAGEMENT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(getAlgorithmTree());
            dispatch(storeShowAlgorithms(data.algorithmIds));
          },
          onCancel: () => {
            dispatch(getAlgorithmTree());
            dispatch(storeShowAlgorithms(data.algorithmIds));
          }
        }));
      } else {
        console.error("fail to update algorithms category");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_MANAGEMENT_MODAL_FAIL_TITLE,
          modalContent: ALGORITHM_MANAGEMENT_MODAL_UPDATE_FAIL_CONTENT,
          modalOk: ALGORITHM_MANAGEMENT_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_MANAGEMENT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};

/**
 * delete algorithms
 */
export const deleteAlgorithms = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: "/api-algorithm/deleteAlgorithms",
    contentType: "application/json",
    withCredentials: true,
    data: data.algorithmIds
  }).then(
    response => {
      if (response.status === 200) {
        console.info("success offline algorithm");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_MANAGEMENT_MODAL_SUCCESS_TITLE,
          modalContent: ALGORITHM_MANAGEMENT_MODAL_OFFLINE_SUCCESS_CONTENT,
          modalOk: ALGORITHM_MANAGEMENT_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_MANAGEMENT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(getAlgorithmTree());
            dispatch(storeShowAlgorithms(data.algorithmIds));
          },
          onCancel: () => {
            dispatch(getAlgorithmTree());
            dispatch(storeShowAlgorithms(data.algorithmIds));
          }
        }));
      } else {
        console.error("fail to offline algorithm");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: ALGORITHM_MANAGEMENT_MODAL_FAIL_TITLE,
          modalContent: ALGORITHM_MANAGEMENT_MODAL_OFFLINE_FAIL_CONTENT,
          modalOk: ALGORITHM_MANAGEMENT_MODAL_OK_LABEL,
          modalCancel: ALGORITHM_MANAGEMENT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};

/**
 * store show algorithms
 */
export const storeShowAlgorithms = (ids) => {
  return {
    type: ALGORITHM_MANAGEMENT_STORE_SHOW_ALGORITHMS,
    data: ids
  }
};

/**
 * search algorithms
 */
export const searchAlgorithmTree = (data) => (dispatch) => {
  let showAlgorithms = data.algorithms.filter(algorithm => {
    return algorithm.name.indexOf(data.searchName) > -1
  });
  dispatch(updateAlgorithmManagementData({
    name: "showAlgorithms",
    value: showAlgorithms
  }));
  dispatch(updateAlgorithmManagementData({
    name: "selectedRowKeys",
    value: []
  }));
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: ALGORITHM_MANAGEMENT_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: ALGORITHM_MANAGEMENT_TOGGLE_LOADING,
    data: show
  }
};
